import { clear, h } from "./dom";
import { pick, t } from "./i18n";
import type { RegionIndexEntry, ViewMode } from "./types";

export function renderPicker(root: HTMLElement, mode: ViewMode): () => void {
  const grid = h("div", { className: "cards" }, h("p", { className: "muted" }, t("viewer.loading")));
  clear(root).append(
    h(
      "div",
      { className: "picker" },
      h("h1", {}, t(`picker.heading.${mode}`)),
      h("p", { className: "intro" }, t("picker.intro")),
      grid,
    ),
  );

  void (async () => {
    let regions: RegionIndexEntry[] = [];
    try {
      const r = await fetch("/data/regions.json");
      if (!r.ok) throw new Error(String(r.status));
      regions = (await r.json()) as RegionIndexEntry[];
    } catch {
      clear(grid).append(h("p", { className: "error" }, t("error.load")));
      return;
    }
    clear(grid);
    regions = regions.filter((r) => (r.modes ?? ["2d"]).includes(mode));
    if (!regions.length) {
      grid.append(h("p", { className: "muted" }, t("picker.empty")));
      return;
    }
    for (const region of regions.sort((a, b) => a.order - b.order)) {
      grid.append(
        h(
          "a",
          { className: "card", href: mode === "3d" ? `#/3d/${region.slug}` : `#/r/${region.slug}` },
          h("img", { src: `/data/regions/${region.slug}/thumb.jpg`, alt: pick(region.name), loading: "lazy" }),
          h("div", { className: "card-body" }, h("h3", {}, pick(region.name)), h("p", {}, pick(region.description))),
        ),
      );
    }
  })();

  return () => undefined;
}
